/**
 * AutoDrive Theme — Recently Viewed Products
 * Stores visited products in localStorage and renders a carousel on the product page.
 */
(function () {
  var STORAGE_KEY = 'autodrive_recently_viewed';
  var MAX_ITEMS   = 8;

  var dataEl = document.getElementById('current-product-data');
  if (!dataEl) return;

  var current;
  try { current = JSON.parse(dataEl.textContent); } catch (e) { return; }

  // Load saved list, strip the current product from it
  var list = [];
  try { list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch (e) {}
  list = list.filter(function (p) { return p.id !== current.id; });

  // Render previously-viewed products BEFORE prepending current
  // so the current product never appears in its own "recently viewed"
  render(list);

  // Prepend current and save back
  list.unshift(current);
  if (list.length > MAX_ITEMS) list = list.slice(0, MAX_ITEMS);
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}

  /* ── Helpers ── */
  function formatMoney(cents) {
    if (!cents) return '';
    return '$' + (cents / 100).toFixed(2);
  }

  function esc(str) {
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(str || ''));
    return d.innerHTML;
  }

  /* ── Render carousel ── */
  function render(products) {
    if (!products.length) return;

    var section = document.getElementById('recently-viewed-section');
    var track   = document.getElementById('recently-viewed-track');
    if (!section || !track) return;

    track.innerHTML = products.map(function (p) {
      var saleHtml = (p.compare_at_price && p.compare_at_price > p.price)
        ? '<span class="price--compare" style="text-decoration:line-through;color:#999;font-size:0.8rem;margin-right:4px;">' + formatMoney(p.compare_at_price) + '</span>'
        : '';

      return '<div class="related-card-wrap">' +
        '<a href="' + esc(p.url) + '" class="product-card" style="text-decoration:none;display:flex;flex-direction:column;">' +
          '<div class="product-card__media" style="position:relative;">' +
            (p.image
              ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy" class="product-card__img" style="width:100%;height:100%;object-fit:contain;">'
              : '<div class="product-card__media-placeholder"></div>'
            ) +
            (!p.available ? '<div class="product-card__soldout-overlay"><span>Sold Out</span></div>' : '') +
          '</div>' +
          '<div class="product-card__body">' +
            '<p class="product-card__title" style="margin:0 0 6px;">' + esc(p.title) + '</p>' +
            '<div class="product-card__price">' + saleHtml + formatMoney(p.price) + '</div>' +
          '</div>' +
        '</a>' +
      '</div>';
    }).join('');

    section.style.display = '';
  }
})();
